import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_SSR_STATUS
    SET_DETAILS
`,
    {
        prefix: "predeliveryinspection/"
    }
);
